module.exports = __webpack_public_path__ + "img/fleetex.736bcb59.png";